import { calculateHours } from '@/utility/CommonFunctions';
import CheckInIcon from '../Icons/CheckInIcon';
import CheckOutIcon from '../Icons/CheckOutIcon';
import TotalHoursIcon from '../Icons/TotalHourIcon';
import LiveClock from './LiveClock';
import { useEffect, useState } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import { formatISTTime, showToastNotification } from '@/utility/helper';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { IAttendanceResponse } from '@/interfaces/attendance.model';
import ClockTooltip from '../Layout/ClockTooltip';
import moment from 'moment';
import CheckInOutConfirmModal from '../Modal/CheckInOutConfirmModal';
import { IDeleteResponse } from '@/interfaces/common.model';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
interface IState {
  checkInTime: string | null;
  checkOutTime: string | null;
  attendanceId: string | null;
}

const TodayAttendence = () => {
  const [state, setState] = useState<IState>({
    checkInTime: null,
    checkOutTime: null,
    attendanceId: null,
  });
  const [loading, setLoading] = useState(false);
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const [checkInOutModal, setCheckInOutModal] = useState<
    'checkIn' | 'checkOut' | null
  >(null);
  const toggleCheckIn = (type?: 'checkIn' | 'checkOut') => {
    setCheckInOutModal(type || null);
  };
  useEffect(() => {
    getCheckInData();
    checkLocationPermission();
  }, []);
  const [locationPermission, setLocationPermission] = useState<boolean>(false);
  const checkLocationPermission = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        () => {
          setLocationPermission(true);
        },
        (error) => {
          console.error('Location permission denied or error:', error);
          setLocationPermission(false);
        },
      );
    } else {
      setLocationPermission(false);
    }
  };
  const handleCheckInOut = async () => {
    if (!checkInOutModal) return;

    try {
      setLoading(true);
      // setLogoutLoading(true);
      // const currentDate = moment().format('YYYY-MM-DD');
      const currentTime = moment().local().format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      const payload: {
        checkInTime?: string;
        checkOutTime?: string;
        attendanceId?: string | null;
      } = {
        // userId: userDetails.id,
        // markingAttendance: true,
        // date: currentDate,
      };
      if (checkInOutModal === 'checkIn') {
        payload.checkInTime = currentTime;
      } else if (checkInOutModal === 'checkOut') {
        payload.checkOutTime = currentTime;
        payload.attendanceId = state?.attendanceId;
      }
      const response: IDeleteResponse = await callApi(
        API_URL + API_ENDPOINT.markAttendance,
        {
          method: 'POST',
          data: payload,
        },
      );
      console.log(response, payload);
      if (response?.status) {
        showToastNotification(
          'success',
          response?.message || 'Attendance Updated',
        );
        setCheckInOutModal(null);
        getCheckInData();
      } else {
        showToastNotification(
          'danger',
          response?.message || 'Failed to update attendance',
        );
      }
    } catch (error) {
      console.log(error);
      showToastNotification('danger', 'Something went wrong');
    } finally {
      setLoading(false);
      // setLogoutLoading(false);
    }
  };
  const getCheckInData = async () => {
    try {
      const API = `${API_URL}${API_ENDPOINT?.getAttendance}?todayAttendance=true&myAttendance=true`;
      const res: IAttendanceResponse = await callApi(API, {
        method: 'GET',
      });
      if (res?.status === true) {
        console.log(res);
        if (res?.data?.attendance?.[0]?.attendances?.[0]) {
          setState((prev) => ({
            ...prev,
            attendanceId: res?.data?.attendance?.[0]?.attendances?.[0]?.id,
            checkInTime:
              res?.data?.attendance?.[0]?.attendances?.[0]?.checkInTime,
            checkOutTime:
              res?.data?.attendance?.[0]?.attendances?.[0]?.checkOutTime,
          }));
        }
      } else {
        showToastNotification('success', res?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };
  return (
    <>
      <div className="col-12 col-xl-3 col-lg-4 col-md-6">
        <div className="card check-in h-100 m-0">
          <div className="card-body h-100 px-2">
            <LiveClock />
            {userDetails?.site?.isPunchAllowed && <div className="d-inline-flex align-items-center gap-3">
              <div>
                <div id="checkin-wrapper" className="d-inline-block" style={!locationPermission ? { cursor: 'not-allowed' } : {}}>
                  <button
                    id="btn-checkin"
                    className="btn btn-outline-primary py-2 px-3 rounded-3 flex-row gap-1 align-items-center"
                    onClick={() => toggleCheckIn('checkIn')}
                    disabled={!!state.checkInTime || !locationPermission}
                    style={!locationPermission ? { pointerEvents: 'none' } : {}}
                  >
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="20"
                        height="20"
                        x="0"
                        y="0"
                        viewBox="0 0 32 32"
                        xmlSpace="preserve"
                        fill-rule="evenodd"
                        className="me-1"
                      >
                        <g>
                          <path
                            d="M24 5h-5V4a1 1 0 0 0-2 0v1h-5V4a1 1 0 0 0-2 0v1H9c-.796 0-1.559.316-2.121.879A2.996 2.996 0 0 0 6 8v7a1 1 0 0 0 2 0v-4h20v15a.997.997 0 0 1-1 1H9a.997.997 0 0 1-1-1v-3a1 1 0 0 0-2 0v3c0 .796.316 1.559.879 2.121A2.996 2.996 0 0 0 9 29h18c.796 0 1.559-.316 2.121-.879A2.996 2.996 0 0 0 30 26V8c0-.796-.316-1.559-.879-2.121A2.996 2.996 0 0 0 27 5h-1V4a1 1 0 0 0-2 0zM10.586 18H3a1 1 0 0 0 0 2h7.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a.999.999 0 0 0 0-1.414l-3-3a1 1 0 0 0-1.414 1.414zM27 7H9a.997.997 0 0 0-1 1v1h20V8a.997.997 0 0 0-1-1z"
                            fill="#0047ab"
                            opacity="1"
                            data-original="#0047ab"
                          ></path>
                        </g>
                      </svg>
                    </span>
                    Check-In
                  </button>
                </div>
                {locationPermission ? <ClockTooltip target="btn-checkin" /> :
                  <UncontrolledTooltip target="checkin-wrapper">
                    Cannot access location
                  </UncontrolledTooltip>
                }
              </div>
              <div>
                <div id="checkout-wrapper" className="d-inline-block" style={!locationPermission ? { cursor: 'not-allowed' } : {}}>
                  <button
                    id="btn-checkout"
                    className="btn btn-outline-primary py-2 px-3 rounded-3 flex-row gap-1 align-items-center"
                    onClick={() => toggleCheckIn('checkOut')}
                    disabled={!state.checkInTime || !!state.checkOutTime || !locationPermission}
                    style={!locationPermission ? { pointerEvents: 'none' } : {}}
                  >
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="20"
                        height="20"
                        x="0"
                        y="0"
                        viewBox="0 0 32 32"
                        xmlSpace="preserve"
                        fill-rule="evenodd"
                        className="me-1"
                      >
                        <g>
                          <path
                            d="M23 30H5a3 3 0 0 1-3-3V6a1 1 0 0 1 1-1h3V2.994a1 1 0 0 1 2 0V5h12V2.994a1 1 0 0 1 2 0V5h3a1 1 0 0 1 1 1v11a1.001 1.001 0 0 1-2 0v-3H4v13c.013.555.445.986 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 1 2 0v2a3 3 0 0 1-3 3zm-5-8 1.6 1.2a1.001 1.001 0 0 1-1.2 1.6l-4-3a1 1 0 0 1 .014-1.61l.001-.002L18.4 17.2a1 1 0 0 1 1.2 1.6L18 20h11a1.001 1.001 0 0 1 0 2zm2-15H8v2l-.001.013A1 1 0 0 1 6 9.006V7H4v5h20V7h-2v2a1.001 1.001 0 0 1-2 .006V9z"
                            fill="#0047ab"
                            opacity="1"
                            data-original="#0047ab"
                          ></path>
                        </g>
                      </svg>
                    </span>
                    Check-Out
                  </button>
                </div>
                {locationPermission ? <ClockTooltip target="btn-checkout" /> :
                  <UncontrolledTooltip target="checkout-wrapper">
                    Cannot access location
                  </UncontrolledTooltip>
                }
              </div>
            </div>}
            <div className="d-flex w-100 justify-content-center align-items-center pt-4 text-nowrap flex-wrap gap-3 gap-lg-5">
              <div className="d-flex flex-column justify-content-center align-items-center time-data">
                <CheckInIcon />
                <p>
                  {state?.checkInTime
                    ? formatISTTime(state?.checkInTime)
                    : '00:00'}
                </p>
                <span>Check In</span>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center time-data">
                <CheckOutIcon />
                <p>
                  {state?.checkOutTime !== null
                    ? formatISTTime(state?.checkOutTime)
                    : '00:00'}
                </p>
                <span>Check Out</span>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center time-data">
                <TotalHoursIcon />
                <p>{calculateHours(state?.checkInTime, state?.checkOutTime)}</p>
                <span>Total Hours</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CheckInOutConfirmModal
        loading={loading}
        isOpen={!!checkInOutModal}
        toggle={() => toggleCheckIn()}
        type={checkInOutModal}

        onConfirm={handleCheckInOut}
      />
    </>
  );
};

export default TodayAttendence;
